import React from 'react';

import CheckIcon from "@mui/icons-material/Check";
import BlockIcon from "@mui/icons-material/Block";
import DeleteIcon from "@mui/icons-material/Delete";
import PublishIcon from '@mui/icons-material/Publish';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { IconButton, Tooltip, ClickAwayListener } from '@mui/material';

export default function ConfirmationButton({ type, tooltip, handleConfirm  }) {

    const [confirm, setConfirm] = React.useState(false);

    let buttonIcon;

    if (type.toLowerCase() === "delete") {
        buttonIcon = <DeleteIcon/>;
    } else if (type.toLowerCase() === "publish") {
        buttonIcon = <PublishIcon/>
	} else if (type.toLowerCase() === "filter") {
		buttonIcon = <FilterAltIcon/>
    } else {
        buttonIcon = <RadioButtonCheckedIcon/>;
    }

    const prepareToConfirm = () => {
        setConfirm(true);
    };

    const cancelConfirm = () => {
        setConfirm(false);
    };

    const handleConfirmClick = () => {
        handleConfirm();
        setConfirm(false);
    };

    // TODO: Use Theme RAG Colors
    return (
        <React.Fragment>
            {!confirm &&
            <Tooltip title={tooltip}>
                <IconButton aria-label="confirm" onClick={prepareToConfirm} size="large">
                    {buttonIcon}
                </IconButton>
            </Tooltip>
            }
            {confirm &&
            <ClickAwayListener onClickAway={cancelConfirm}>
                <div style={{display: 'inline-flex'}}>
                    <Tooltip title={tooltip ? tooltip : "Confirm"}>
                        <IconButton aria-label="confirm" onClick={handleConfirmClick} size="large">
                            <CheckIcon style={{color: "green"}}/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Cancel">
                        <IconButton aria-label="cancel" onClick={cancelConfirm} size="large">
                            <BlockIcon style={{color: "red"}}/>
                        </IconButton>
                    </Tooltip>
                </div>
            </ClickAwayListener>
            }
        </React.Fragment>
    );
}
